var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"my-4"},[_vm._v("Hello from modal!")])
}
var staticRenderFns = []

export { render, staticRenderFns }